export const slots = {
    'prod': { label: 'Production', },
    'staging': { label: 'Staging', },
};

export default slots;
